import React, { useState, useRef, Fragment, useEffect } from "react";
import useInfiniteScroll from "../../helpers/useInfiniteScroll";
import { history } from "../../helpers/history";
import cardHolderService from "../../services/cardholder.service";
import validator from "validator";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import ExportToExcel from "../superadmin/ExportToExcel";
import DialoguePopup from "../../helpers/DialoguePopup";
import ModelPopup from "../../helpers/ModelPopup";
import { Link } from "react-router-dom";
import BoLoader from "../../helpers/BoLoader";

const SearchGridInputData = [
  {
    TokenId: "",
    CardHolderName: "",
    ClientId: "",
    PageSize: 20,
    StartIndex: 1,
    PageNo: 1,
    FetchAll: false,
    scrolled: false,
  },
];
var fontStyle = {
  textTransform: "uppercase",
};
const DeclineAuthTransactionGrid = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [name, setCompanyName] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [clientId, setclientId] = useState("");
  const searchTbl = useRef();
  const [loadingData, setLoadingData] = useState(false);
  const [searchData, setSearchData] = useState();
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [SearchInputDisabled, setSearchDisabled] = useState(false);
  const [clientIdVal, setClientIdVal] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [classContent, setClassContent] = useState("tab-content");
  const [dataset, setDataset] = useState();
  const [confirmmodalShow, setCnfrmModalShow] = useState(false);
  //Dialouge Popup Error Messages
  const [modalShowDialouge, setModalShowDialouge] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [modelbdy, setMdlBdy] = useState("");
  //Success Message
  const [modalsuccessfullShow, setModalsuccessfullShow] = useState(false);
  const [boloader, setBoLoader] = useState(false);
  const [userId, setUserId] = useState();

  const errorAndSuccessModl = (heading, body, Icon) => {
    setModalShowDialouge(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(Icon);
  };
  useEffect(() => {
    SearchClickHandler()
   
  }, []);
 
  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchDisabled(true);
  };
  const nameChangeHandler = (e) => {
    SearchGridInputData[0].Name = e.target.value;
    setCompanyName(e.target.value);
  };
  const onChangeTokenId = (e) => {
    SearchGridInputData[0].TokenId = e.target.value;
    setTokenId(e.target.value);
  };

  const SearchClickHandler = (e,isFromUseEffect) => {
    setLoadingData(true);
    if (!SearchGridInputData[0].scrolled) {
      setSearchGridSuccess(false);
    }
    setModalShow(false);
    setModalShow(false);
    setSearchDisabled(false);
    cardHolderService
      .getdeclineauthtransactioncount(
        SearchGridInputData[0].TokenId.toString(),
        SearchGridInputData[0].CardHolderName.toString(),
        SearchGridInputData[0].ClientId.toString(),
        SearchGridInputData[0].PageSize,
        SearchGridInputData[0].StartIndex,
        SearchGridInputData[0].PageNo,
        SearchGridInputData[0].FetchAll,
      )
      .then((resp) => {
        setLoadingData(false);
        if (resp && resp?.data && resp?.data?.payload) {
          if (resp.data.success) {
            setModalShow(false);
            setSearchDisabled(false);
          }
          if (
            resp.data.payload?.pageModel?.length > 0 ||
            searchData.length > 0
          ) {
            setTotalCount(resp.data.payload?.totalCount);
            let sortedData = resp.data.payload?.pageModel
            .slice() // Create a copy to avoid mutating original array
            .sort((a, b) => b.declineCount - a.declineCount);
            if (SearchGridInputData[0].scrolled) {
              let appendedData = searchData.concat(sortedData);
              setSearchData(appendedData);
             props?.setDataset(appendedData);
            } else {
              setSearchData(sortedData);
             props?.setDataset(resp.data.payload?.pageModel);
              SearchGridInputData[0].startIndex = 1;
            }
            setSearchGridSuccess(true);

            SearchGridInputData[0].scrolled = false;
            searchTbl.current.onscroll = tblScrollHandler;
            SearchGridInputData[0].isFirstTime = false;
          }
        }
      })
      .catch((error) => {
        setSearchGridSuccess(false);
        setLoadingData(false);
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            SearchClickHandler();
          }
        })();
      });
  };
  const tblScrollHandler = (e) => {
    if (
      !SearchGridInputData[0].scrolled &&
      SearchGridInputData[0].StartIndex + 20 <= totalCount
    ) {
      SearchGridInputData[0].scrolled = true;
      SearchGridInputData[0].StartIndex =SearchGridInputData[0].StartIndex + 20;
      SearchGridInputData[0].PageNo =SearchGridInputData[0].PageNo + 1;
      SearchClickHandler();
    }
  };

  // Sentinel-driven pagination — see helpers/useInfiniteScroll.js.
  // The onScroll/onWheel handlers above only fire when the table element
  // itself scrolls; .table-wrap is overflow-x only and touch devices emit
  // no wheel event, so on mobile the list silently stopped loading. The
  // handler carries its own stop condition, so hasMore is passed as true.
  const infiniteScrollRef = useInfiniteScroll(tblScrollHandler, true, false);
 
  const renderTableHeader = () => {
    let header = Object.values(props.headersdata);
    return header.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  };
 
  const showCardHolderDetailPage = (id,userId,issuerCategory) => {
    history.push("/cardholderdetails", {id,userId,issuerCategory});
  };
  const renderTableData = () => {
    return searchData.map((data, index) => {
      const {
        Id ,
        tokenId,
        clientName ,
        ClientId ,
        cardHolderName ,
        declineCount ,
        createdAt ,
        cardUserId,
        userId,
        cardholderUUID,
        issuerCategory
      } = data; //destructuring
      return (
        <tr key={index}>
          
          <td style={fontStyle}>{clientName}</td>
          <td>  <span style={{ color:'#0d6efd'}}   title="View Card Holder Details" onClick={() => showCardHolderDetailPage(cardholderUUID,userId,issuerCategory)} >{tokenId}</span></td>
          <td style={fontStyle}>{cardHolderName}</td>
          <td style={fontStyle}>{declineCount}</td>
          <td><DateFormat date={createdAt} /></td> 
        </tr>
      );
    });
  };
  const HideSearchPopupDiv = () => {
    setModalShow(false);
    setSearchDisabled(false);
    setTokenId("");
    setCompanyName("");
  };
  const ClearSearchData = () => {
    SearchGridInputData[0].TokenId="";
    SearchGridInputData[0].CardHolderName="";
    SearchGridInputData[0].ClientId="";
    SearchGridInputData[0].PageSize=20;
    SearchGridInputData[0].StartIndex=1;
    SearchGridInputData[0].PageNo=1;
    SearchGridInputData[0].FetchAll=true;
    setTokenId("");
    setCompanyName("");
    ClearInputData();
  };
  const ClearInputData = () => {
    if (document.getElementById("clientNameDD") !== null)
      document.getElementById("clientNameDD").value = "";
    setClientIdVal("");
    setTimeout(() => {
      [...document.getElementsByClassName("r-input-group")].forEach(
        (element) => {
          element.children[0].value = "";
        }
      );
      document.getElementById("searchBtnClients").click();
    }, 500);
  };

  return (
    <div className="mt-0 mt-sm-4">
      <div className={classContent} id="myTabContent2">
      <BoLoader loading={boloader} />
        <div
          className="tab-pane fade show active"
          id="allClients"
          role="tabpanel"
          aria-labelledby="allClients-tab"
        >
          {/* no client found  */}
          <div className="d-flex align-content-center justify-content-center no-clients-msg d-none">
            <div className="text-center">
              <span className="icon-clients-empty">
                <span className="path1"></span><span className="path2"></span>
                <span className="path3"></span><span className="path4"></span>
                <span className="path5"></span><span className="path6"></span>
              </span>
              {/* <img src="../../assets/images/icons/clients-empty.svg" /> */}
              <h3>Empty Transactions Listing</h3>
              <h6>There is no Transaction(s) available for now.</h6>
            </div>
          </div>
          <Fragment>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row row-search">
                <div className="col-xl-12 col-12">
                  <div className="form-group">
                    <div className="form-controls">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.placeholdervalue}
                        onClick={handleInputSearchClick}
                        disabled={SearchInputDisabled}
                      />
                      <span className="icon-search _ico"></span>
                      {/* search box  */}
                      <div
                        className="bo-cardsearch"
                        style={{ display: modalShow ? "" : "none" }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="col-md-4">
                            <img
                              className="cross-icon cross-modal"
                              src={crossImgs}
                              aria-label="Close"
                              onClick={HideSearchPopupDiv}
                              alt=""
                            />
                            </div>
                            <div className=" col-md-12 form-group form-search mr-20">
                              <label>Name</label>
                              <div className="form-controls mr-20">
                                <input
                                  type="text"
                                  value={name}
                                  onChange={nameChangeHandler}
                                  className="form-control"
                                  maxLength={20}
                                />
                              </div>
                            </div>
                            <div className=" col-md-12 form-group form-search mr-20">
                              <label>Token Id</label>
                              <div className="form-controls mr-20">
                                <input
                                  type="text"
                                  value={tokenId}
                                  onChange={onChangeTokenId}
                                  className="form-control"
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                  
                  <div className="form-controls"></div>
                </div>
                          <div className="col-md-12">
                            <div className="form-group submit-field form-search">
                              <button
                                id="searchBtnClients"
                                className="btn btn-large mr-19"
                                onClick={SearchClickHandler}
                              >
                                Search
                              </button>
                              <button
                                className="btn btn-outline"
                                onClick={ClearSearchData}
                              >
                                Clear Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="help-block d-none"></span>
                  </div>
                </div>
              </div>
            </form>
          </Fragment>
        </div>

        {searchGridSuccess && (
          <div className="table-wrap" ref={searchTbl}>
            <table
              className="table table-borderless bo-table table-cards"
              onScroll={tblScrollHandler}
              onWheel={tblScrollHandler}
            >
              <thead>
                <tr>{renderTableHeader()}</tr>
              </thead>
              <tbody>{renderTableData()}</tbody>
            </table>
            <div ref={infiniteScrollRef} aria-hidden="true" className="bopay-scroll-sentinel" />
          </div>
        )}
        {loadingData ? (
          <div className="loading-more">
            <div className="loader">
              <div></div>
            </div>
            <p>loading data</p>
          </div>
        ) : totalCount === 0 ? (
          <div className="d-flex align-content-center justify-content-center  no-clients-msg">
            <div className="text-center">
              <span className="icon-clients-empty">
                <span className="path1"></span><span className="path2"></span>
                <span className="path3"></span><span className="path4"></span>
                <span className="path5"></span><span className="path6"></span>
              </span>
              {/* <img src={emptyclient} /> */}
              <h3>Empty Transaction Listing</h3>
              <h6>There is no Transaction(s) available for now.</h6>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <DialoguePopup
        show={modalShowDialouge}
        onHide={() => setModalShowDialouge(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      
      />
    </div>
  );
};

export default DeclineAuthTransactionGrid;
